import { render, staticRenderFns } from "./divComponent.vue?vue&type=template&id=3f3e8a43&scoped=true&"
import script from "./divComponent.vue?vue&type=script&lang=js&"
export * from "./divComponent.vue?vue&type=script&lang=js&"
import style0 from "./divComponent.vue?vue&type=style&index=0&id=3f3e8a43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3e8a43",
  null
  
)

export default component.exports